import FAQItem from './FAQItem';
import { FAQItemProps, FAQItemValueProps } from './types';

export type { FAQItemProps, FAQItemValueProps };
export default FAQItem;
